import { sendGroupDB } from '@/scripts/dataBase';
import type {
  ChatGroup,
  ChatGroupGroupId,
  ChatGroupParams,
} from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { genChatGroups } from '@/contexts/chat/scripts/hooks/useChatGroup/utils';
import { ActionType } from '@/scripts/dataBase/type';

const groupsDBApis = {
  getAllGroups() {
    return sendGroupDB<ChatGroup[]>(ActionType.queryGroups, {
      params: { limit: -1, offset: 0 },
    });
  },
  getGroups(ids: ChatGroupGroupId[]) {
    return Promise.all(
      ids.map((id) =>
        sendGroupDB<ChatGroup>(ActionType.queryGroupByGroupId, {
          params: id,
        })
      )
    );
  },
  insertGroups(args: ChatGroupParams[]) {
    return sendGroupDB(ActionType.addGroups, {
      params: genChatGroups(args),
    });
  },
  updateGroups(args: ChatGroupParams[]) {
    return sendGroupDB(ActionType.updateGroups, {
      params: args,
    });
  },
  removeGroups(args: ChatGroupGroupId[]) {
    return sendGroupDB(ActionType.deleteGroups, {
      params: args.toString(),
    });
  },
};

export const groupApis = {
  getAllGroups() {
    return groupsDBApis.getAllGroups();
  },
  getGroups(ids: ChatGroupGroupId[]) {
    return groupsDBApis.getGroups(ids);
  },
  insertGroups(args: ChatGroupParams[]) {
    return groupsDBApis.insertGroups(args);
  },
  updateGroups(args: ChatGroupParams[]) {
    return groupsDBApis.updateGroups(args);
  },
  removeGroups(ids: ChatGroupGroupId[]) {
    return groupsDBApis.removeGroups(ids);
  },
};
